"use strict";
window.theme = window.theme || {}
theme.ComponentsMainCollection = function() {
    function ComponentsMainCollection() {
        this.button = {
            sorting: document.querySelector('.filter-container a.collection-sorting'),
            filtering: document.querySelector('.filter-container a.collection-filtering')
        }
        this.container = {
            productgrid: document.getElementById('CollectionProductGrid')
        }
        this.load();             
    }
    ComponentsMainCollection.prototype.load = function() {
        var _ = this;        
            _.button.sorting.addEventListener('click', event => {
                event.target.closest('a').querySelector('i').classList.toggle('active');
                event.target.closest('[data-section-type="collection-section"]').querySelector('.collection__filtering').classList.toggle('active');
                event.target.closest('[data-section-type="collection-section"]').querySelector('.collection__sidebar-filters').classList.remove('active');
            });
            _.button.filtering.addEventListener('click', event => {
                event.target.closest('a').querySelector('i').classList.toggle('active');
                event.target.closest('[data-section-type="collection-section"]').querySelector('.collection__sidebar-filters').classList.toggle('active');
                event.target.closest('[data-section-type="collection-section"]').querySelector('.collection__filtering').classList.remove('active');
            });
    }
    theme.ComponentsMainCollection = new ComponentsMainCollection;
}

theme.ComponentsMainCollection();
